// Lightweight green toast for dev notifications
// Usage: showDevNotification("Notification: Welcome email sent!")

let devToastContainer: HTMLDivElement | null = null;

function ensureDevToastContainer(): HTMLDivElement {
  if (devToastContainer && document.body.contains(devToastContainer)) return devToastContainer;
  devToastContainer = document.createElement('div');
  devToastContainer.id = 'dev-toast-container';
  Object.assign(devToastContainer.style, {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: '2147483647',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    pointerEvents: 'none',
  } as CSSStyleDeclaration);
  document.body.appendChild(devToastContainer);
  return devToastContainer;
}

export function showDevNotification(message: string): void {
  const container = ensureDevToastContainer();

  const toast = document.createElement('div');
  Object.assign(toast.style, {
    background: '#10b981', // green
    color: 'white',
    border: '1px solid rgba(0,0,0,0.08)',
    borderRadius: '16px',
    padding: '18px 24px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial',
    fontSize: '16px',
    lineHeight: '1.5',
    maxWidth: '640px',
    width: 'min(90vw, 640px)',
    textAlign: 'center',
    pointerEvents: 'auto',
    opacity: '0',
    transform: 'translateY(6px)',
    transition: 'opacity 160ms ease, transform 200ms ease',
    cursor: 'pointer',
  } as CSSStyleDeclaration);

  const text = document.createElement('div');
  text.textContent = message;
  toast.appendChild(text);

  const hint = document.createElement('div');
  hint.textContent = 'Click to dismiss';
  Object.assign(hint.style, { fontSize: '12px', opacity: '0.9', marginTop: '6px' } as CSSStyleDeclaration);
  toast.appendChild(hint);

  container.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });

  function dismiss() {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(6px)';
    window.setTimeout(() => {
      if (toast.parentElement) toast.parentElement.removeChild(toast);
    }, 200);
  }

  toast.addEventListener('click', () => {
    dismiss();
  });
}